<!-- Template for the action button that parent component can render -->
<ng-template #actionButton>
  <iris-button
    id="pendo-insurance-submission"
    data-test="insurance-save-button"
    [type]="IrisButtonTypes.PRIMARY"
    [typeAttribute]="IrisButtonTypeAttributeOptions.SUBMIT"
    [disabled]="submitting || !allowNext"
    (click)="newClientSubmit()"
  >
    <ng-container *ngIf="!submitting; else spinner">Next</ng-container>

    <ng-template #spinner>
      <mat-spinner
        *ngIf="!chcHasAnOutageFeatureFlag"
        class="button-spinner"
        diameter="24"
        aria-label="Submission is processing"
      ></mat-spinner>

      <div *ngIf="chcHasAnOutageFeatureFlag" class="button-loading-with-message">
        <mat-spinner
          class="button-spinner"
          diameter="24"
          aria-label="Submission is processing"
        ></mat-spinner>
        <div class="loading-message">Submission is processing</div>
      </div>
    </ng-template>
  </iris-button>
</ng-template>

@if (fromDirectBooking) {
  <div class="preamble">
    <h1 class="heading">You're nearly there</h1>
    <p class="edit-profile-insurance-message">
      Please add your insurance information.
    </p>
  </div>
}

<div [class.from-direct-booking]="fromDirectBooking">
  <div
    *ngIf="!hideContent"
    class="insurance-wrapper sondermind-design-system buffer-bottom"
  >
    @if (!fromDirectBooking) {
      <h1 class="iris-h1-responsive">Complete your account</h1>
      <p class="edit-profile-insurance-message iris-body-responsive">
        We need a little more information so that you're all set for your first therapy session.
      </p>
    }
    <h2 class="iris-h2-resonsive" data-test="insurance-section-header-text">How do you want to cover the cost of your sessions?</h2>
    <p data-test="add-insurance-card-question-text">
      <ng-container *ngIf="showInsuranceHelperText">
        You indicated you would like to use insurance to help pay for therapy.
        <br>
        <br>
      </ng-container>
      In order to use your insurance to help pay for therapy, we need some more details. You'll need your insurance card handy to complete this form.
    </p>
    <iris-radio-group
      id="pendo-setup-insurance-radio-group"
      [options]="yesOrNo"
      [formControl]="addingInsuranceControl"
      data-test="add-insurance-radio-option"
    >
    </iris-radio-group>
  </div>

  <client-insurance-add
    [useInline]="true"
    [useInSessionRequest]="useInSessionRequest"
    [ngClass]="{'hide-visually': !addingInsuranceControl.value}"
    (closeAdd)="onInsuranceAddClosed($event)"
    (hideParentContent)="onHideParentContent($event)"
  ></client-insurance-add>

  <div *ngIf="addingInsuranceControl.value && !hideContent">
    <p class="iris-body-responsive">
      If you'd like to use more than one insurance plan,
      you can add it once your account is complete (find it under "Account," and then "Insurance").
    </p>
  </div>

  <iris-button-container *ngIf="!hideContent && !fromDirectBooking" [alignment]="IrisButtonContainerAlignments.END">
    <ng-container *ngTemplateOutlet="actionButton"></ng-container>
  </iris-button-container>
</div>

